$(document).ready(function () {
  jQuery('.ben-3 label').show();
  jQuery('.ben-2 .color-option2 .variant-input').on('click',function(){
      var label_txt = jQuery(this).find('input').val();
    //  console.log(label_txt);
      jQuery('.ben_label .variant__label-info span').text(label_txt);
  }); 
  jQuery('.ben-3 .color-option3 .variant-input').on('click',function(){
      var label_txt = jQuery(this).find('input').val();
    //  console.log(label_txt);
      jQuery('.ben_label .variant__label-info span').text(label_txt);
  });
  jQuery('.farve .select_color_img').on('click',function(){
     var color_title = jQuery(this).parent().attr('data-value');
     jQuery('.farve_label .variant__label-info span').text(color_title);
 });
  var btn_text = jQuery('.cart_btn_popup').html();
jQuery('<div class="mobile-btn">'+btn_text+'</div>').insertAfter('.variation_mobile');

jQuery('.option2 .variant-input').each(function( index ) {
  var opt_val = jQuery(this).find('input').val();
   jQuery('.size_dropdown').append('<option value="'+opt_val+'">'+opt_val+'</option>');
});  
jQuery('.size_dropdown').on('click',function(){
  var a = jQuery(this).val();
    jQuery('.option2 .variant-input').each(function( index ) {
       var opt_val = jQuery(this).find('input').val();
        if(a == opt_val)
        {
            jQuery(this).find('input').trigger('click');
        }
    });  
});
 var size_length = $('.size_dropdown > option').length;
    if(size_length >=2)
    {
      jQuery('.size_dropdown').show();
      jQuery('.option2 .variant-input .size_label_varinat').hide();
     
    } else {
      jQuery('.size_dropdown').hide(); 
      jQuery('.option2 .variant-input .size_label_varinat').show();
}
jQuery( ".option3 .variant-input" ).each(function( index ) {
       // console.log(jQuery(this).find('input').val());
        if (!jQuery(this).find('input').prop("checked")) {  
           jQuery(this).addClass('uncheck_radio')
        }
   });   
jQuery('.skift-retning-link').on('click',function(){
 // alert('test12');       
  jQuery('.uncheck_radio input').trigger('click');
  jQuery(".option2 .variant-input").removeClass('uncheck_radio');
  jQuery( ".option2 .variant-input" ).each(function( index ) {
       // console.log(jQuery(this).find('input').val());
        if (!jQuery(this).find('input').prop("checked")) {  
           jQuery(this).addClass('uncheck_radio')
        }
   });  
});
  jQuery('.skift-retning-link').on('click',function(){
 // alert('test12');       
  jQuery('.uncheck_radio input').trigger('click');
  jQuery(".option3 .variant-input").removeClass('uncheck_radio');
  jQuery( ".option3 .variant-input" ).each(function( index ) {
       // console.log(jQuery(this).find('input').val());
        if (!jQuery(this).find('input').prop("checked")) {  
           jQuery(this).addClass('uncheck_radio')
        }
   });  
});
jQuery('.farve-3').insertBefore('.størrelse-2');

jQuery('.size_label').on('click',function(){
   // jQuery('.size_label_varinat').toggleClass('show_size_variant');
});  
jQuery('.mobile-header .header-item--logo').remove();
jQuery('#CartTermsDrawer').on('click',function(){
  if ($('#CartTermsDrawer').prop('checked')==true){ 
    jQuery('.cart__checkout').removeClass('disable_payment');
  } else {
   //  jQuery('<div class="condition_error">jeg accepterer vilkår og betingelser</div>').insertBefore('.cart__terms');
     jQuery('.cart__checkout').addClass('disable_payment');
  }
});   
setTimeout(function(){
 $( ".product__thumbs--scroller .product__thumb-item" ).each(function() {
         var  img_attr = jQuery(this).attr('data-index');
   console.log(img_attr+'------------test');
        if(img_attr == 'none')
          {
              jQuery(this).addClass('img_3d');
          }
   });         
},2000);      
if(jQuery(window).width() < 767){
  
 //var logo_html = jQuery('').html();
  jQuery('.desktop-header .header-item--logo').insertAfter('.mobile-header .menu-below');
 
  jQuery('html').addClass('loader_product');   
  jQuery('.product__thumbs--scroller').addClass('owl-carousel');
  jQuery('.product__thumbs--scroller').addClass('owl-theme');
  jQuery('.product__thumbs--scroller').hide();
 setTimeout(function(){
   jQuery('html').removeClass('loader_product');
   jQuery('.product__thumbs--scroller').show();
       jQuery('.product__thumbs--scroller').owlCarousel({
          stagePadding: 30,
          loop:true,
          margin:10,
          nav:true,
          navText: [
          '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0Z"></path></svg>',
          '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><title>icon-chevron</title><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98Z"></path></svg>'
        ],
          responsive:{
              0:{
                  items:3
              },
              600:{
                  items:3
              },
              1000:{
                  items:3
              }
          }
      });
 },3000);          
  jQuery('.variation_mobile').insertBefore('.product-block--header');
}
  
  jQuery('.mobile-nav__item').on('click',function(){
    jQuery(".video_wrap .video-img-wrap").hide();    
    var menu_id = jQuery(this).attr('data-id');
    $( ".video_wrap .video-img-wrap" ).each(function() {
       
      var video_id = jQuery(this).attr('data-id');
        if(menu_id == video_id)
        {
            jQuery(this).show();
        }
    });
});
jQuery('.color_search_2').hide();
//================== Search page js ===================== 
    jQuery( ".template-search .color_search_0 .img_collection_wrap" ).each(function( index ) {
      var img_url  = $(this).find('.color_img img').attr('src');
      var imageUrl =  "https:"+img_url;
                 $(this).find(".color-swatch").css("background-image", "url(" + imageUrl + ")");   
    }); 
    
    jQuery( ".template-search .grid--uniform .grid-product" ).each(function( index ) {
          var link_produ = jQuery(this).find('.grid-product__link').attr('href');
          var var_count = jQuery(this).find(".grid-product__colors").children().length;
          jQuery(this).find(".color_search_0").children().hide();
          jQuery(this).find('.color_search_0 div:lt(9)').show();
          jQuery(this).find(".color_img").hide();
    });  
  jQuery( ".template-search .grid--uniform .grid-product" ).each(function( index ) {
    var link_produ = jQuery(this).find('.grid-product__link').attr('href');
    var var_count = jQuery(this).find(".color_search_0").children().length;
     var total = parseFloat(var_count ) - Number(5);
  if(var_count > 5)
  {
    var link_href = '<a href="'+link_produ+'">+'+total+'</a>';
     jQuery('<span style="display:block;">'+link_href+'</span>').appendTo(jQuery(this).find(".color_search_0"));
  }
}); 
//========================== header js =============================  
  jQuery('.video-image').on('click',function(){
    jQuery(this).parent().find('.video-url-tag').show();
    jQuery(this).hide();
  });

 jQuery('.video-img-wrap').on('click',function(){
   $(this).find('video').get(0).play();
 }); 
 $(window).scroll(function(){
    var aTop = $('#shopify-section-template--20522892558603__background-image-text').height();
    if($(this).scrollTop()>=aTop){
       $('.product_image_wrap').removeClass('img-sticky');
        // instead of alert you can use to show your ad
        // something like $('#footAd').slideup();
    } else {
      $('.product_image_wrap').addClass('img-sticky');
    }
  });
//======================  product page js ========================  
$('.show_more').on('click',function(){
    $('.long_description').show();
    $('.show_more').hide();
    $('.read_less').show();
    $('.short_description').hide();
});
 $('.template-page .image-wrap').izoomify({
            url: "https://magelig.dk/cdn/shop/files/Alpine_18_Dark_brown.png",
            magnify: 2.75,
            duration: 450,
            touch: true,
            callback: function () {
                //your code here..
            }
        }); 
$('.read_less').on('click',function(){
  $('.read_less').hide();
  $('.long_description').hide();
  $('.short_description').show();
  $('.show_more').show();
  $('html, body').animate({
        'scrollTop' : $(".short_description").position().top
    });
}); 
jQuery('.toolbar').insertAfter('.announcement-bar');

jQuery('.size_arrow').on('click',function(){
  jQuery('html').addClass('size-popup');
  jQuery('.size-info-wrap').show();
  jQuery('.size_close').show();
  jQuery('.size_arrow').hide();  
}); 
jQuery('.size_close').on('click',function(){
  jQuery('html').removeClass('size-popup');
  jQuery('.size-info-wrap').hide();
  jQuery('.size_close').hide();
  jQuery('.size_arrow').show(); 
  
});


// jQuery('.color-option1 .select_color_img').on('click',function(){
//   jQuery('.color-div-wrap').show();
//   jQuery('.popup_close').insertBefore('.color-div-wrap');
//   jQuery('.popup_close').show();
 
//   $( ".product__thumbs--scroller .product__thumb-item" ).each(function() {
//          var  img_attr = jQuery(this).attr('data-index');
//    console.log(img_attr+'------------test');
//         if(img_attr == 'none')
//           {
//               jQuery(this).addClass('img_3d');
//               jQuery(this).trigger('click');
//           }      
//    });      
//  // jQuery('.product__thumbs .product__thumbs--scroller .test12').trigger('click');
//   jQuery('html').addClass('color-open-html')
//    jQuery('.farve-1 .farve_label').insertBefore('.color-div-wrap');
//   jQuery('.color-febaric-wrap').hide();
//   jQuery('.febric-div-wrap').empty();
//   jQuery('.color-div-wrap').empty(); 
//  var color_img = jQuery(this).parent().find('.color-febaric-wrap .color_img').html();
//  var febric_info = jQuery(this).parent().find('.color-febaric-wrap .febric-wrap').html();
//   console.log(color_img);
//    jQuery(color_img).appendTo( ".color-div-wrap" );
//    jQuery(febric_info).appendTo( ".febric-div-wrap" );
//   jQuery('.febric-div-wrap').insertAfter('.farve-1');

// });  
  
jQuery('.popup_arrow').on('click',function(){
  
  jQuery('.variant-input').addClass('popup_variant');
  jQuery('html').addClass('open-popup');
  jQuery('.popup_close').show();
  jQuery('.popup_arrow').hide();
  jQuery('.farve-1 .farve_label').insertBefore('.color-div-wrap');
  jQuery('.cart_btn_popup').insertAfter('.febric-div-wrap');
  jQuery( ".variant-input-wrap .variant-input" ).each(function( index ) {
     jQuery(this).find('input').is(':checked')
      if(jQuery(this).find('input').is(':checked'))
      {
       var color_img = jQuery(this).find('.color_img').html();
        var febric_info = jQuery(this).find('.febric-wrap').html();
          jQuery(color_img).appendTo( ".color-div-wrap" );
          jQuery(febric_info).appendTo( ".febric-div-wrap" );
      }
  
    });
});  
  jQuery('.variant-input').on('click',function(){
    jQuery('.variant-input').removeClass('selected-variant');
     jQuery('.variant-input').addClass('unselected-variant');
    jQuery(this).addClass('selected-variant'); 
    jQuery(this).removeClass('unselected-variant'); 
  }); 
 jQuery('.popup_close').on('click',function(){
   jQuery('.color-div-wrap').hide();
     jQuery('.farve-1 .farve_label').insertAfter('.popup_arrow');
  jQuery('.febric-div-wrap').empty();
  jQuery('.color-div-wrap').empty(); 
  jQuery('.variant-input').removeClass('popup_variant');
  jQuery('html').removeClass('open-popup');
  jQuery('html').removeClass('color-open-html'); 
  jQuery('.popup_close').hide();
  jQuery('.febric-wrap').hide();
  jQuery('.color_img').hide(); 
  jQuery('.popup_arrow').show();
  
}); 
//=================== oakling product js ===============
setTimeout(function(){
  jQuery( ".oakling-variant-input-wrap .variant-input" ).each(function( index ) {
    var img_url  = $(this).find('.oakling_color_img img').attr('src');
    var imageUrl =  "https:"+img_url;
               $(this).find(".select_color_img").css("background-image", "url(" + imageUrl + ")");   
  }); 
},500);  

//===============================  
jQuery( ".variant-input-wrap .variant-input" ).each(function( index ) {
  var img_url  = $(this).find('.color-febaric-wrap img').attr('src');
  var imageUrl =  "https:"+img_url;
             $(this).find(".select_color_img").css("background-image", "url(" + imageUrl + ")");   
});  
jQuery( ".template-collection .grid-product__colors .img_collection_wrap" ).each(function( index ) {
  var img_url  = $(this).find('.color_img img').attr('src');
  var imageUrl =  "https:"+img_url;
             $(this).find(".color-swatch").css("background-image", "url(" + imageUrl + ")");   
});

jQuery( ".template-collection .grid--uniform .grid__item" ).each(function( index ) {
     var link_produ = jQuery(this).find('.grid-product__link').attr('href');
    var var_count = jQuery(this).find(".color_search_0").children().length;
     var total = parseFloat(var_count ) - Number(5);
  if(var_count > 5)
  {
    var link_href = '<a href="'+link_produ+'">+'+total+'</a>';
     jQuery('<span style="display:block;">'+link_href+'</span>').appendTo(jQuery(this).find(".color_search_0"));
  }
});    
 
jQuery('.mobile-search-icon').on('click',function(){
    jQuery('.mobile_search_form').show();
    jQuery('.mobile-search-icon').hide();
    jQuery('html').addClass('search-mobile');
});  

jQuery('.close-form').on('click',function(){
  jQuery('.mobile_search_form').hide();
  jQuery('.mobile-search-icon').show();
  jQuery('html').removeClass('search-mobile');
})  
// $("div").delegate(".farve-1 .select_color_img", "click", function(){
//     jQuery('.febric-div-wrap').empty();
//     jQuery('.color-div-wrap').empty();
//   var color_img = jQuery(this).parent().find('.color_img').html();
//   var febric_info = jQuery(this).parent().find('.febric-wrap').html();
//   jQuery('.farve-1 .farve_label').insertBefore('.color-div-wrap');
  
//     jQuery(color_img).appendTo( ".color-div-wrap" );
//     jQuery(febric_info).appendTo( ".febric-div-wrap" );
//     jQuery('.febric-div-wrap').insertAfter('.farve-1');
// }); 

//============ collection page js ============
  jQuery( ".template-collection .grid--uniform .grid__item" ).each(function( index ) {
      var link_produ = jQuery(this).find('.grid-product__link').attr('href');
      var var_count = jQuery(this).find(".grid-product__colors").children().length;
        var total = parseFloat(var_count ) - Number(5);
      jQuery(this).find(".grid-product__colors").children().hide();
      jQuery(this).find('.grid-product__colors div:lt(9)').show();
      jQuery(this).find(".color_img").hide();
   });  
  
//=========== home page js ===================
    jQuery( ".template-index .grid--uniform .grid__item" ).each(function( index ) {
      var link_produ = jQuery(this).find('.grid-product__link').attr('href');
      var var_count = jQuery(this).find(".grid-product__colors").children().length;
      jQuery(this).find(".grid-product__colors").children().hide();
      jQuery(this).find('.grid-product__colors div:lt(9)').show();
      jQuery(this).find(".color_img").hide();
   }); 

jQuery( ".template-index .grid-product__colors .img_collection_wrap" ).each(function( index ) {
  var img_url  = $(this).find('.color_img img').attr('src');
  var imageUrl =  "https:"+img_url;
             $(this).find(".color-swatch").css("background-image", "url(" + imageUrl + ")");   
});

jQuery( ".template-index .grid--uniform .grid__item" ).each(function( index ) {
     var link_produ = jQuery(this).find('.grid-product__link').attr('href');
    var var_count = jQuery(this).find(".color_search_0").children().length;
     var total = parseFloat(var_count ) - Number(5);
  if(var_count > 5)
  {
    var link_href = '<a href="'+link_produ+'">+'+total+'</a>';
     jQuery('<span style="display:block;">'+link_href+'</span>').appendTo(jQuery(this).find(".color_search_0"));
  }
   
}); 
setTimeout(function(){  
    jQuery('.grid-product__colors span').show(); 
  },200);
});

//===============================
$('.ad_cart').click(function(e) {
e.preventDefault();

  var items = [  
    { id: 45990082642187, quantity: 1 } 
];  
  $.ajax({  
      type: 'POST',  
      url: '/cart/add.js',  
      data: { items: items },  
      dataType: 'json',  
      success: function() {  
         alert('Success handling code');  
      },  
      error: function() {  
          alert('Error handling code');  
      }  
  
      });
    }); 

  // Function to update the cart display
  function updateCart(cart) {
    // Update the cart count in the header or wherever you show the cart icon
    $('#cart-count').text(cart.item_count);

    // Optionally, you could update the cart items or show a mini cart popup here.
    // Example: updateCartTotal(cart);
  }

 //================== detail page shipping date js ================ 
  var iDag = new Date();
    var leveringsStart = new Date(iDag.getTime() + 42 * 24 * 60 * 60 * 1000); // 6 uger frem
    var leveringsSlut = new Date(iDag.getTime() + 56 * 24 * 60 * 60 * 1000); // 8 uger frem

    // Formater leveringsdatoer
    var dagStart = leveringsStart.getDate();
    var maanedStart = leveringsStart.getMonth() + 1; // Måneder er 0-indekserede
    var aarStart = leveringsStart.getFullYear();

    var dagSlut = leveringsSlut.getDate();
    var maanedSlut = leveringsSlut.getMonth() + 1; // Måneder er 0-indekserede
    var aarSlut = leveringsSlut.getFullYear();

    // Indsæt estimeret leveringsdato i informationsbaren
   const leveringEl = document.getElementById("leverings-info");
if (leveringEl) {
  leveringEl.innerHTML = 
    "Forventet levering - Ved bestilling i dag:<br>" + 
    dagStart + "/" + maanedStart + "/" + aarStart + " - " + 
    dagSlut + "/" + maanedSlut + "/" + aarSlut;
}


//
// RO CRO js - hide Chat & Accessibility before consent
//
//  $(document).ready(function () {
//     var currentUrl = window.location.pathname;

//     if (currentUrl.indexOf("heaven-roomy-sofa-4-personers-sofa") !== -1) {
//       $(".advanced-sec").hide();
//     }
//   });